import { MyCampApp } from '../common/enumerations';

export class TextMessage
{
    TextMessageType!: MyCampApp.TextMessageType;
    Body!: string;
    Date!: Date;

    constructor(json?: any)
    {
        if (json) Object.assign(this, json);
    }
}
